import { enGB, roRO } from '../../../modules/Locales'

export const loginText = 'loginText'
export const titlePartOne = 'titlePartOne'
export const titlePartTwo = 'titlePartTwo'
export const managerText = 'managerText'

export const locales = {
  [enGB]: {
    [loginText]: 'Login',
    [titlePartOne]: 'Your Voice',
    [titlePartTwo]: 'Engagement Platform',
    [managerText]: 'Managers'
  },
  [roRO]: {
    [loginText]: 'Autentificare',
    [titlePartOne]: 'Your Voice',
    [titlePartTwo]: 'Engagement Platform',
    [managerText]: 'Manageri'
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/libs/locales.js